import { isFunction, isObject } from "./utils";

const loaded = [] as string[]

export function loadScript(src: string, onload: () => any = null) {

    if (check(src, onload)) return

    const script: HTMLScriptElement = document.createElement("script");

    script.onload = () => registerOnLoad(src, onload)

    script.src = src

    document.head.appendChild(script)

}

export function loadStylesheet(href: string, onload?: () => any) {

    if (check(href, onload)) return

    const link: HTMLLinkElement = document.createElement("link")

    link.rel = "stylesheet"
    link.type = "text/css"
    link.href = href

    link.onload = () => registerOnLoad(href, onload)


    document.head.appendChild(link)

}

export function loadScripts(src: string[], onload?: () => any) {

    let pending = src.length

    src.forEach(s => loadScript(s, () => {

        if (!(--pending)) {
            call(onload)
        }

    }))
}

function check(src: string, callback: () => any) {
    if (loaded.some(i => i == src)) {
        call(callback)
        return true
    }
}

function registerOnLoad(src: string, callback: () => any) {
    loaded.push(src)
    call(callback)
}

function call(callback: () => any) {
    if (isFunction(callback)) {
        callback()
    }
}

function checkForReact() {
    return isObject(window["React"])
}
